// Package tier: owns the back half of the URL and the method, so this is the whole operation
// minus the payload -- the call layer imports it and does nothing but inject data.
// Not a hook: it receives the already-built HTTP client instead of building one, which is what
// lets a router with many endpoints share a single client no matter how many packages it grows.
// Nothing here names the library, so swapping axios out only touches api/clients.
export const getIndsPrices             = (client) => client.post("/indx-prices-for-indices");

export const postCosPricesForCategory = (client, payload) => client.post("/cos-prices-for-category", payload);

